import React from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import LottiePlayer from "lottie-react";
import Filter from '../../Filter/Filter';
import nodatafound from '../../../assets/animationicons/nodatafound.json'
import { CancelIcon, SearchesCIcon } from '../../../SvgIconsData';
import { CloseIcon } from '../../../assets/icons/iconshere';

const UserFileTab = ({ setUserLength, search="", setSearch="", roleList=[], onSelect }) => {
    var params = useParams();
    const userData = useSelector((state) => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    var { groupId } = params;
    const [usersList, setUsersList] = useState([]);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [filterOptions, setFilterOptions] = useState([]);


    let fetchUsers = async () => {
        setUserLength(0)
        try {
            let { data } = await axios.get(`${configData.config.UNO_URL}/api/user/list/${groupId}`, {
                headers: {
                    'Authorization': `Bearer ${userData.token}`
                }
            });

            let uniqueArrayDesignation = (([...new Set(data.data.map((e) => e.designation ? e.designation.trim() : "Undefined"))]).sort()).map(e =>({id:e, name:e}));
            setUsersList(data.data);
            setUserLength(data.data.length)
            let formattedDesignationData = {
                name: "Designation",
                tags: uniqueArrayDesignation
            };

            let formattedAllocationData = {
                name: "Role",
                tags:  (roleList.map((e) => ({id : e.id , name : e.name}))).sort((c, d) => c.name.localeCompare(d.name))
            }

            setFilterOptions([formattedAllocationData, formattedDesignationData]);

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchUsers();
    }, [groupId]);

    useEffect(() => {
        setSelectedCheckboxes([]);
    }, []);

    const handleCancelTag = (item) => {
        setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
     };

    const filterCourses = (user => {
        if (search.length && !( (user.name && (user.name.toLowerCase().includes(search.toLowerCase())))  || (user.email && (user.email.toLowerCase().includes(search.toLowerCase()))) || (user.uid && (user.uid.toLowerCase().includes(search.toLowerCase()))) ) ) return false;

        if (selectedCheckboxes.length)
        {
            var designationFilters = (selectedCheckboxes.filter((e)=> typeof e.id == 'string'));
            var roleFilters = (selectedCheckboxes.filter((e) => !designationFilters.includes(e))).map(e => e.id);
            const roleallocation = user.roleAllocations.length > 1 ? user.roleAllocations.filter(e => e.role.type !== 'DEFAULT')[0] : user.roleAllocations[0];
            const { role } = roleallocation;
            if (roleFilters.length && !roleFilters.includes(role.id)) return false;
            if (designationFilters.length &&  !(designationFilters.map(e => e.id)).includes(user.designation)) return false;
        } 
        return true;
    });

    let filteredList = usersList.filter(filterCourses);

    return (
        <>  
            <div className='row pt-4 mt-3'>
            <div className='col-md-12 d-flex align-items-center justify-content-end'>
                <form className=" app-search app-search1 d-flex justify-content-start me-2">
                        <div className="position-relative">
                            <SearchesCIcon />
                            {search.length > 0 && <span className='searchiconcancel' onClick={()=>setSearch("")} >
                                <CancelIcon />
                            </span>}
                            <input
                                type="text"
                                name="searchName"
                                className="form-control"
                                placeholder="Search"
                                autoComplete="off"
                                value={search}
                                onChange={(e)=>setSearch(e.target.value)}
                            />
                        </div>
                    </form>
                    <Filter
                        selectedCheckboxes={selectedCheckboxes}
                        setSelectedCheckboxes={setSelectedCheckboxes}
                        filterOptions={filterOptions}
                    />
            </div>
            </div>

            {selectedCheckboxes.length > 0 && 
                    <div className='filerlist mt-3'>
                    <span>Filters:</span> 
                        {selectedCheckboxes.map(f =>{
                            return(
                                <span className='filtertag'>
                                    {f.name} 
                                    <span onClick={()=>handleCancelTag(f)} ><CloseIcon /></span>
                                </span>
                            )
                    })}
                    <span className='filtertag clear' onClick={()=> setSelectedCheckboxes([])} style={{cursor:"pointer"}}>
                        Clear all
                    </span>
                    </div>
                         }

            <div className='courses-parent usergrouplist'>
                { filteredList.length > 0 ? 
                       <div className="course-tiles mt-3">
                { filteredList.map((user, index) => (
                        <div className="tilecard p-0" key={index} onClick={() => onSelect(user)}>
                            <div className='usercardesign' key={user.id}>
                                {user.avatar ? (
                                    <div className='avatarimg'>
                                        <img src={user.avatar} referrerPolicy='no-referrer' alt={`Avatar for ${user.name}`} title={user.name} />
                                    </div>
                                ):(
                                    <div className='initials-placeholder'>
                                        {user?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                    </div>
                                )}
                                <h6 className='groupname'>{user.name}</h6>
                                <p>{user.email}</p>
                            </div>
                        </div>
                    )) }
                        </div>
                    :
                    <div className="text-center mt-5">
                        <LottiePlayer
                            animationData={nodatafound}
                            style={{ height: 200 }}
                            autoplay
                            loop
                        />
                        <h5>No User Found</h5>
                    </div>
                }
            </div>
        </>
    )
}

export default UserFileTab
